import React, { Component } from "react";

import classnames from "classnames";

import AOS from "aos";
import "aos/dist/aos.css";

export default class FAQs extends Component {
  constructor(props) {
    super(props);
    this.openQuestion = this.openQuestion.bind(this);
    this.state = {
      question: 0,
    };
  }

  componentDidMount() {
    AOS.init({
      duration: 3000,
    });
  }

  openQuestion(num) {
    if (this.state.question === num) {
      this.setState((prevState) => ({
        question: 0,
      }));
    } else {
      this.setState((prevState) => ({
        question: num,
      }));
    }
  }

  render() {
    return (
      <div id="FAQs">
        <h2 className="FAQs__header">
          Frequently Asked Questions
        </h2>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              What is a Zip?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(1);
              }}
              className="symbol"
            >{this.state.question === 1 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 1
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              <div>
              The new form of digital self-service for user onboarding, training and support is known as in-app guides. 
              In- app guides are step by step guides that appear for a user in real-time. In the Ziplyne world, we call 
              these guides, Zips. You can see a sample of a Zip in the screenshots above.
              </div>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              How do I get access to Ziplyne?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(2);
              }}
              className="symbol"
            >{this.state.question === 2 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 2
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              <div>
                Access to Ziplyne can be achieved seamlessly via the button
                above. If there are any issues with the extension or the
                downloading process, please refer to the contact information
                below.
              </div>
              <div>
                If you are an existing user and need some help/assistance please
                contact: Ziplyne Support:{" "}
                <a href="mailto:Ziplyne_support@lists.johnshopkins.edu">
                  Ziplyne_support@lists.johnshopkins.edu
                </a>
              </div>
              <div>
                If you are a brand new user, and want to be onboarded please
                contact:{" "}
                <a href="mailto:Ziplyne@lists.johnshopkins.edu">
                  Ziplyne@lists.johnshopkins.edu
                </a>
              </div>
              <div>
                If you already have MS Teams, then you can reach out to a
                Channel for Support{" "}
                <a href="https://teams.microsoft.com/l/channel/19%3ae88bda8bd36148adb77ef2756f5f6fbe%40thread.tacv2/Post%2520a%2520Problem?groupId=c230710c-3291-4ae1-a507-2561875297a4&tenantId=9fa4f438-b1e6-473b-803f-86f8aedf0dec">
                  here
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              How do I know if I have the Creator or Player installed correctly?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(3);
              }}
              className="symbol"
            >{this.state.question === 3 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 3
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              <div>
                You will see a blue Z or a ? icon appear on your screen as an end user using the Player. 
                You will know that the Ziplyne Creator is activated and functioning if it is visible on the page as a purple Z icon.
              </div>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              {" "}
              Who do I have to talk at Johns Hopkins in order to get trained?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(4);
              }}
              className="symbol"
            >{this.state.question === 4 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 4
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              <div>
                You can book a time to attend a Ziplyne Training Session via the
                link in the above section. Training Sessions for the Johns
                Hopkins User Community are offered roughly once a month.
              </div>
              <div>
                We need to learn a little more information about you and your
                department and what Application/ Use case you are looking to use
                Ziplyne for.
              </div>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              What is the cost of Ziplyne for me and/or my department?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(5);
              }}
              className="symbol"
            >{this.state.question === 5 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 5
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              <div>
                There is no cost associated with playing back the already
                existing Zips at Johns Hopkins Enterprise as an end user.
              </div>
              <br />
              <div>
                The cost of Ziplyne for your department to Create your own Zips
                or guides, depends on multiple factors such as application type,
                the number of expected end users and the number of guides needed
                for your use case.
              </div>
              <br />
              <div>Zipster as a Service:</div>
              <div>
                On Demand/ Project based Zip creation with a Ziplyne Specialist. For more information on this
                service, please reachout to the {" "}
                <a href="mailto:ziplyne@lists.johnshopkins.edu">
                  ziplyne@lists.johnshopkins.edu
                </a>
              </div>
              <br />
              <div>Custom Requirements:</div>
              <div>
                Training for large groups ( outside of standard training)
              </div>
              <div>Customized Deployments & Development</div>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              How fast can I see results from Ziplyne?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(6);
              }}
              className="symbol"
            >{this.state.question === 6 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 6
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer">
              In some simple situations, results can be seen immediately. The
              business impact can be observed by the decrease in support
              tickets, faster onboarding times, higher employee productivity and
              decrease in number of training sessions/ follow-ups needed for the
              end-user community across the enterprise applications at Johns
              Hopkins.
            </div>
          </div>
        </div>
        <div className="QuestionAnswer">
          <div className="QuestionAnswer__questionWrap">
            <h2 className="QuestionAnswer__question">
              How do I know if Ziplyne will work/integrate with my application?
            </h2>
            <div
              className="QuestionAnswer__button"
              onClick={() => {
                this.openQuestion(7);
              }}
              className="symbol"
            >{this.state.question === 7 ? "-" : "+"}</div>
          </div>
          <div
            className={classnames(
              "QuestionAnswer__answerWrap",
              this.state.question === 7
                ? "QuestionAnswer__answer--animation"
                : ""
            )}
          >
            <div className="QuestionAnswer__answer"> 
              Ziplyne can sit on top of virtually any web-based application
              (including SAP, Mendix, ServiceNow, Kronos), as well as customized
              web sites and applications. Ziplyne is currently working together
              with Johns Hopkins to develop a solution for
              compatibility/integrations with Epic. For more information on this
              initiative, please contact {" "} 
              <a href="mailto:ziplyne@lists.johnshopkins.edu">
                ziplyne@lists.johnshopkins.edu
              </a>
            </div>
          </div>
        </div>
        <div className="QuestionAnswer__buttonEnd">
          <span
            onClick={() =>
              window.open(
                "https://teams.microsoft.com/l/channel/19%3a477ae07e82674fe8a532426e7b32519f%40thread.tacv2/General?groupId=c230710c-3291-4ae1-a507-2561875297a4&tenantId=9fa4f438-b1e6-473b-803f-86f8aedf0dec"
              )
            }
          >
            Join the Ziplyne User Group at Johns Hopkins
          </span>
        </div>
      </div>
    );
  }
}
